import React from "react";
import { Text, View, StyleSheet } from "react-native";
import Svg, { Path } from "react-native-svg";

export default function TextIcon(props) {
  return (
    <View style={styles.container}>
      <Svg
        width={props.width !== undefined ? props.width : 24}
        height={props.height !== undefined ? props.height : 20}
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M3.63574 15.1295L3.50435 15.2803L3.63574 15.1295C3.51415 15.0236 3.45225 14.8863 3.45225 14.75C3.45225 14.6137 3.51415 14.4764 3.63574 14.3705L3.50435 14.2197L3.63574 14.3705C3.75821 14.2637 3.92954 14.2 4.11299 14.2L20.754 14.2C20.9375 14.2 21.1088 14.2637 21.2313 14.3705C21.3528 14.4764 21.4147 14.6137 21.4147 14.75C21.4147 14.8863 21.3528 15.0236 21.2313 15.1295C21.1088 15.2363 20.9375 15.3 20.754 15.3L4.11299 15.3C3.92953 15.3 3.75821 15.2363 3.63574 15.1295ZM3.63574 12.1295L3.50435 12.2803L3.63574 12.1295C3.51415 12.0236 3.45225 11.8863 3.45225 11.75C3.45225 11.6137 3.51415 11.4764 3.63574 11.3705L3.50435 11.2197L3.63574 11.3705C3.75821 11.2637 3.92954 11.2 4.11299 11.2L20.754 11.2C20.9375 11.2 21.1088 11.2637 21.2313 11.3705C21.3528 11.4764 21.4147 11.6137 21.4147 11.75C21.4147 11.8863 21.3528 12.0236 21.2313 12.1295C21.1088 12.2363 20.9375 12.3 20.754 12.3L4.11299 12.3C3.92954 12.3 3.75821 12.2363 3.63574 12.1295ZM3.63574 9.12954L3.50435 9.28033L3.63574 9.12954C3.51415 9.02359 3.45225 8.88628 3.45225 8.75C3.45225 8.61372 3.51415 8.47641 3.63574 8.37046L3.50435 8.21967L3.63574 8.37046C3.75821 8.26375 3.92954 8.2 4.11299 8.2L20.754 8.2C20.9375 8.2 21.1088 8.26375 21.2313 8.37046C21.3528 8.47641 21.4147 8.61372 21.4147 8.75C21.4147 8.88628 21.3528 9.02359 21.2313 9.12954C21.1088 9.23625 20.9375 9.3 20.754 9.3L4.11299 9.3C3.92954 9.3 3.75821 9.23625 3.63574 9.12954ZM21.2313 6.12954C21.1088 6.23625 20.9375 6.3 20.754 6.3L9.85127 6.3C9.66782 6.3 9.49649 6.23625 9.37402 6.12954C9.25243 6.02359 9.19053 5.88628 9.19053 5.75C9.19053 5.61372 9.25243 5.47641 9.37402 5.37046C9.49649 5.26375 9.66782 5.2 9.85127 5.2L20.754 5.2C20.9375 5.2 21.1088 5.26375 21.2313 5.37046C21.3528 5.47641 21.4147 5.61372 21.4147 5.75C21.4147 5.88628 21.3528 6.02359 21.2313 6.12954Z"
          fill={props.fill !== undefined ? props.fill : "#545454"}
          stroke="white"
          strokeWidth="0.4"
        />
      </Svg>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});
